<div class="modems">
  <div class="modems__label">
    <h3>{{ 'pages.restaurantAccount.modems' | translate }}</h3>
  </div>

  <form
    *ngIf="editable"
    class="modem modem--form"
    [formGroup]="modemForm"
    (ngSubmit)="createModem()"
  >
    <mat-form-field class="modem__field">
      <mat-label>{{ 'pages.restaurantAccount.phoneNumber' | translate }}</mat-label>
      <input
        matInput
        appFormInputTrim
        formControlName="phoneNumber"
        [maxlength]="shortFieldMaxLength"
      >
      <mat-error *ngIf="modemForm.get('phoneNumber')?.hasError('maxlength')">
        {{ 'pages.restaurantAccount.modemFieldMaxLength' | translate:{ max: shortFieldMaxLength } }}
      </mat-error>
      <mat-error *ngIf="modemForm.get('phoneNumber')?.hasError('pattern')">
        {{ 'pages.restaurantAccount.phoneNumberValidation' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="modem__field">
      <mat-label>{{ 'pages.restaurantAccount.routerInfo' | translate }}</mat-label>
      <input
        matInput
        appFormInputTrim
        formControlName="routerInfo"
        [maxlength]="shortFieldMaxLength"
      >
      <mat-error *ngIf="modemForm.get('routerInfo')?.hasError('maxlength')">
        {{ 'pages.restaurantAccount.modemFieldMaxLength' | translate:{ max: shortFieldMaxLength } }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="modem__field modem__field--notes">
      <mat-label>{{ 'pages.restaurantAccount.notes' | translate }}</mat-label>
      <textarea
        matInput
        appFormInputTrim
        formControlName="notes"
        rows="1"
        [maxlength]="notesMaxLength"
      ></textarea>
      <mat-error *ngIf="modemForm.get('notes')?.hasError('maxlength')">
        {{ 'pages.restaurantAccount.modemNotesMaxLength' | translate:{ max: notesMaxLength } }}
      </mat-error>
    </mat-form-field>

    <div class="modem__control">
      <button
        class="btn btn__primary btn__icon"
        type="submit"
        [disabled]="modemForm.invalid || savingModem"
        [matTooltip]="'pages.restaurantAccount.addModem' | translate"
      >
        <mat-icon>add</mat-icon>
        <span class="add">{{ 'pages.restaurantAccount.addModem' | translate }}</span>
      </button>
    </div>
  </form>

  <div class="modem__empty" *ngIf="modemsLoading">
    {{ 'pages.restaurantAccount.modemsLoading' | translate }}
  </div>

  <div class="modem__empty" *ngIf="!modemsLoading && !modems.length">
    {{ 'pages.restaurantAccount.noModems' | translate }}
  </div>

  <div class="modem modem--header" *ngIf="!modemsLoading && modems.length">
    <span class="modem__item">{{ 'pages.restaurantAccount.phoneNumber' | translate }}</span>
    <span class="modem__item">{{ 'pages.restaurantAccount.routerInfo' | translate }}</span>
    <span class="modem__item">{{ 'pages.restaurantAccount.notes' | translate }}</span>
    <span class="modem__item">{{ 'pages.restaurantAccount.updatedAt' | translate }}</span>
    <span class="modem__item modem__item--actions"></span>
  </div>

  <div
    class="modem modem--row"
    [class.modem--row-notes-expanded]="isNotesExpanded(modem.id)"
    *ngFor="let modem of modems"
  >
    <ng-container *ngIf="editingModemId === modem.id; else modemView">
      <form
        class="modem__edit-form"
        [formGroup]="editModemForm"
      >
        <mat-form-field class="modem__field">
          <mat-label>{{ 'pages.restaurantAccount.phoneNumber' | translate }}</mat-label>
          <input
            matInput
            appFormInputTrim
            formControlName="phoneNumber"
            [maxlength]="shortFieldMaxLength"
          >
          <mat-error *ngIf="editModemForm.get('phoneNumber')?.hasError('maxlength')">
            {{ 'pages.restaurantAccount.modemFieldMaxLength' | translate:{ max: shortFieldMaxLength } }}
          </mat-error>
          <mat-error *ngIf="editModemForm.get('phoneNumber')?.hasError('pattern')">
            {{ 'pages.restaurantAccount.phoneNumberValidation' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="modem__field">
          <mat-label>{{ 'pages.restaurantAccount.routerInfo' | translate }}</mat-label>
          <input
            matInput
            appFormInputTrim
            formControlName="routerInfo"
            [maxlength]="shortFieldMaxLength"
          >
          <mat-error *ngIf="editModemForm.get('routerInfo')?.hasError('maxlength')">
            {{ 'pages.restaurantAccount.modemFieldMaxLength' | translate:{ max: shortFieldMaxLength } }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="modem__field modem__field--notes">
          <mat-label>{{ 'pages.restaurantAccount.notes' | translate }}</mat-label>
          <textarea
            matInput
            appFormInputTrim
            formControlName="notes"
            rows="2"
            [maxlength]="notesMaxLength"
          ></textarea>
          <mat-error *ngIf="editModemForm.get('notes')?.hasError('maxlength')">
            {{ 'pages.restaurantAccount.modemNotesMaxLength' | translate:{ max: notesMaxLength } }}
          </mat-error>
        </mat-form-field>

      </form>
    </ng-container>

    <ng-template #modemView>
      <div class="modem--item">
        <sub>{{ 'pages.restaurantAccount.phoneNumber' | translate }}</sub>
        <span>{{ modem.phoneNumber || '-' }}</span>
      </div>

      <div class="modem--item">
        <sub>{{ 'pages.restaurantAccount.routerInfo' | translate }}</sub>
        <span>{{ modem.routerInfo || '-' }}</span>
      </div>

      <div class="modem--item modem--item-notes">
        <sub>{{ 'pages.restaurantAccount.notes' | translate }}</sub>
        <span [class.modem__notes-expanded]="isNotesExpanded(modem.id)">{{ modem.notes || '-' }}</span>
        <button
          *ngIf="shouldShowNotesToggle(modem.notes)"
          class="modem__note-toggle"
          type="button"
          (click)="toggleNotes(modem.id)"
        >
          {{ (isNotesExpanded(modem.id) ? 'pages.restaurantAccount.showLess' : 'pages.restaurantAccount.showMore') | translate }}
        </button>
      </div>

      <div class="modem--item">
        <sub>{{ 'pages.restaurantAccount.updatedAt' | translate }}</sub>
        <span>{{ modem.updatedAt | date: 'medium' }}</span>
      </div>
    </ng-template>

    <div
      class="modem__actions"
      [class.solo]="editingModemId !== modem.id"
      *ngIf="editable"
    >
      <button
        class="btn btn__icon edit-modem"
        type="button"
        [disabled]="deletingModemId === modem.id || savingModem"
        [matTooltip]="(editingModemId === modem.id ? 'pages.restaurantAccount.cancel' : 'pages.restaurantAccount.edit') | translate"
        (click)="startEdit(modem)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24" height="24" viewBox="0 0 24 24" style=" fill:#000000;">
          <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
        </svg>
      </button>

      <div class="modem__controls">
        <button
          class="btn btn__icon delete-modem"
          type="button"
          [ngClass]="{'visible': editingModemId === modem.id, 'hidden': editingModemId !== modem.id}"
          [disabled]="deletingModemId === modem.id || savingModem"
          [matTooltip]="'pages.restaurantAccount.deleteModem' | translate"
          (click)="confirmDelete(modem)"
        >
          <svg width="24px" height="24px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0" fill="#f44336"/>
            <path d="m350.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0" fill="#fafafa"/>
          </svg>
        </button>

        <button
          class="btn btn__icon save-modem"
          type="button"
          [ngClass]="{'visible': editingModemId === modem.id, 'hidden': editingModemId !== modem.id}"
          [disabled]="editModemForm.invalid || !editModemForm.dirty || savingModem"
          [matTooltip]="'pages.restaurantAccount.save' | translate"
          (click)="updateModem()"
        >
          <svg width="24px" height="24px" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 60a30 30 0 1 1 30-30 30 30 0 0 1-30 30ZM13 36.8a3.5 3.5 0 0 1 0-5l1.8-1.7a3.2 3.2 0 0 1 4.6 0l3 3.3a1.6 1.6 0 0 0 2.4 0L40.7 17a3.2 3.2 0 0 1 4.6 0l1.7 1.7a3.5 3.5 0 0 1 0 4.9L25.9 45a3.2 3.2 0 0 1-4.6 0Z" fill="#7973CA" fill-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
